import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import TimelineListPage from './components/timeline/TimelineListPage';
import Dashboard from './components/iam/Dashboard';
import LoginPage from './components/iam/LoginPage';
import SignUpPage from './components/iam/SignUpPage';
import InvitationValidationPage from './components/iam/InvitationValidationPage';
import ResetPasswordPage from './components/iam/ResetPasswordPage';
import { IntegrationsPage } from './components/integrations';
import { AggregationAnalysisPage } from './components/analysis';
import { ContactsPage } from './components/contacts';
import SuperAdminTenantManagementPage from './components/admin/superadmin/SuperAdminTenantManagementPage';
import SuperAdminTenantDetailPage from './components/admin/superadmin/SuperAdminTenantDetailPage';
import ReprocessingPage from './components/admin/superadmin/ReprocessingPage';
import LifecycleListPage from './components/lifecycle/LifecycleListPage';
import LifecycleDetailPage from './components/lifecycle/LifecycleDetailPage';
import McpTokensPage from './components/iam/McpTokensPage';
import McpSetupDocsPage from './components/docs/McpSetupDocsPage';
import ChatPanel from './components/ai/ChatPanel';

// Component to handle layout based on route
function AppLayout() {
  const location = useLocation();
  const isAuthPage = ['/login', '/signup', '/invitation', '/reset-password'].includes(location.pathname);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Handle window resize for responsive layout
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auth pages layout - clean, no navigation
  if (isAuthPage) {
    return (
      <div style={{ 
        minHeight: '100vh',
        backgroundColor: 'var(--bg-secondary)',
        color: 'var(--text-primary)'
      }}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/invitation" element={<InvitationValidationPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
        </Routes>
      </div>
    );
  }

  // Main app layout with navigation
  const mainContentStyle = {
    minHeight: '100vh',
    marginLeft: isMobile ? '0' : '200px',
    paddingTop: isMobile ? '60px' : '0',
    transition: 'var(--transition-standard)',
    backgroundColor: 'var(--bg-secondary)'
  };

  const pageContainerStyle = {
    padding: isMobile ? '1rem' : '2rem',
    maxWidth: '100%',
    transition: 'var(--transition-standard)',
    minHeight: isMobile ? 'calc(100vh - 60px)' : '100vh'
  };

  const appContainerStyle = {
    minHeight: '100vh',
    backgroundColor: 'var(--bg-secondary)',
    color: 'var(--text-primary)',
    transition: 'var(--transition-standard)'
  };

  return (
    <div style={appContainerStyle}>
      {/* Admin Watermark removed from global layout */}
      
      <Navigation/>
      
      <main style={mainContentStyle}>
        <div style={pageContainerStyle}>
          <Routes>
            {/* Authenticated Routes */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="/integrations" element={<IntegrationsPage />} />
            <Route path="/analysis" element={<AggregationAnalysisPage />} />
            <Route path="/admin/super" element={<SuperAdminTenantManagementPage />} />
            <Route path="/admin/super/tenants/:tenantId" element={<SuperAdminTenantDetailPage />} />
            <Route path="/admin/reprocessing" element={<ReprocessingPage />} />
            <Route path="/timeline-list" element={<TimelineListPage />} />
            <Route path="/lifecycles" element={<LifecycleListPage />} />
            <Route path="/lifecycles/:key" element={<LifecycleDetailPage />} />
            <Route path="/mcp-tokens" element={<McpTokensPage />} />
            <Route path="/docs/mcp-setup" element={<McpSetupDocsPage />} />

            {/* Default redirect to dashboard */}
            <Route path="/" element={<AggregationAnalysisPage />} />
          </Routes>
        </div>
      </main>

      <ChatPanel />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App; 